import { IconeProprio, type PropsIcone } from './base'

/**
 * Ícones próprios do salvamento veicular. Existem porque nenhuma biblioteca
 * genérica tem calço escalonado, cunha de resgate ou escudo lágrima, e porque
 * substituir esses por um símbolo aproximado ensinaria a forma errada.
 */

import { IconeEstabilizacao } from './IconeEstabilizacao'
import { IconeExtracao } from './IconeExtracao'
import { IconeOficinaCorte } from './IconeOficinaCorte'

/** Calço escalonado de resgate: perfil de 5 degraus, alça e base sólida. */
export const IconeCalco = IconeEstabilizacao

/** Cunha de resgate: o perfil triangular visto de lado. */
export const IconeCunha = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M3 18h18L3 8z" />
  </IconeProprio>
)

/** Bloco de cribbing: uma peça só, vista em perspectiva. */
export const IconeBloco = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M4 10l4-3h12v7l-4 3H4z" />
    <path d="M4 10h12v7" />
    <path d="M16 10l4-3" />
  </IconeProprio>
)

/** V-Strut: escora telescópica com sapata articulada, cabeça dentada e cinta catraca em triangulação. */
export const IconeVStrut = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M3 21h6" />
    <path d="M6 21L17 5" />
    <path d="M15 4h5v3" />
    <path d="M6 20l14-4" />
    <path d="M20 16L17 5" />
    <path d="M9.5 15.5l2.5-1.5" />
  </IconeProprio>
)

/** Fita catraca: a cinta com a catraca no meio. */
export const IconeFitaCatraca = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M2 12h6" />
    <path d="M16 12h6" />
    <rect x="8" y="8" width="8" height="8" rx="1.5" />
    <path d="M10.5 12h3" />
  </IconeProprio>
)

/** Placa de vidro: o retângulo com o reflexo diagonal. */
export const IconeVidro = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <path d="M8 16L16 8" />
  </IconeProprio>
)

/** Detritos de vidro: cacos espalhados. */
export const IconeDetritosVidro = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M5 8l3-3 2 4z" />
    <path d="M14 5l4 2-2 3z" />
    <path d="M4 17l4-2 1 4z" />
    <path d="M14 15l5 1-3 3z" />
  </IconeProprio>
)

/** Cobertor maleável: o pano caindo em dobras. */
export const IconeCobertor = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M4 6h16v10a4 4 0 01-4 4H8a4 4 0 01-4-4z" />
    <path d="M9 6v14" />
    <path d="M15 6v14" />
  </IconeProprio>
)

/** Escudo lágrima: a proteção rígida em forma de gota. */
export const IconeLagrima = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M12 3c4 4.5 6 7.5 6 10.5A6 6 0 016 13.5C6 10.5 8 7.5 12 3z" />
  </IconeProprio>
)

/** Prancha rígida longa de imobilização e extração de resgate. */
export const IconePrancha = IconeExtracao

/** Boneco anatômico de resgate com colar cervical, segmentos corporais e eixo espinhal. */
export const IconeVitima = (p: PropsIcone) => (
  <IconeProprio {...p}>
    {/* Cabeça */}
    <circle cx="12" cy="4.2" r="2.2" />
    {/* Colar cervical */}
    <path d="M10 7.2h4" />
    {/* Tronco anatômico */}
    <path d="M7.5 9h9v6a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 7.5 15z" />
    {/* Eixo da coluna */}
    <path d="M12 7.5v9" />
    {/* Braços nas laterais */}
    <path d="M7.5 10.5 5 15" />
    <path d="M16.5 10.5 19 15" />
    {/* Pernas / membros inferiores */}
    <path d="M9.5 16.5v5" />
    <path d="M14.5 16.5v5" />
  </IconeProprio>
)

export const IconeVitimaBoneco = IconeVitima

/** Ocupantes do veículo em formato técnico. */
export const IconeOcupantes = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <circle cx="8.5" cy="5" r="2" />
    <path d="M5 16v-3a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5V16" />
    <circle cx="16.5" cy="6.5" r="1.7" />
    <path d="M13.5 16v-2.2a1.2 1.2 0 0 1 1.2-1.2h3.6a1.2 1.2 0 0 1 1.2 1.2V16" />
  </IconeProprio>
)

/** Meia-prancha dorsal / KED para imobilização tóraco-lombar. */
export const IconeMeiaPrancha = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M6 3h12v11l-4 6h-4l-4-6z" />
    <path d="M6 7.5h12" />
    <path d="M6 11.5h12" />
    <path d="M12 3v17" />
  </IconeProprio>
)

/** Veículo sobre as quatro rodas. */
export const IconeVeiculoSobreRodas = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M3 13l2.5-5h13l2.5 5" />
    <path d="M3 13h18v4H3z" />
    <circle cx="6.5" cy="18" r="2" />
    <circle cx="17.5" cy="18" r="2" />
    <path d="M10 8v5M14 8v5" />
  </IconeProprio>
)

/** Veículo tombado lateralmente sobre o solo. */
export const IconeVeiculoTombado = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M13 3l-5 2.5v13l5 2.5" />
    <path d="M13 3v18h4V3z" />
    <circle cx="18" cy="6.5" r="2" />
    <circle cx="18" cy="17.5" r="2" />
    <path d="M8 10h5M8 14h5" />
  </IconeProprio>
)

/** Veículo capotado / invertido sobre o teto. */
export const IconeVeiculoCapotado = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <circle cx="6.5" cy="6" r="2" />
    <circle cx="17.5" cy="6" r="2" />
    <path d="M3 11h18v-4H3z" />
    <path d="M3 11l2.5 5h13l2.5-5" />
    <path d="M10 16v-5M14 16v-5" />
  </IconeProprio>
)

/** Porta aberta. */
export const IconePortaAberta = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M4 3h16v18H4z" />
    <path d="M4 3l10 2v14l-10 2z" />
    <circle cx="11.5" cy="12" r=".8" />
  </IconeProprio>
)

/** Porta fechada. */
export const IconePortaFechada = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="4" y="3" width="16" height="18" rx="1.5" />
    <circle cx="8" cy="12" r=".9" />
  </IconeProprio>
)

/** Tampa traseira / porta-malas do veículo. */
export const IconeTampaTraseira = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M4 18h16" />
    <path d="M5 18V8l7-4 7 4v10" />
    <path d="M12 4v8" />
    <path d="M9 12h6" />
  </IconeProprio>
)

/** Poste: o mastro com a base. */
export const IconePoste = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M12 3v16" />
    <path d="M8 21h8" />
    <path d="M12 6h5" />
  </IconeProprio>
)

/** Defensa metálica: o perfil ondulado do guard-rail. */
export const IconeDefensa = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M3 9h18" />
    <path d="M3 14h18" />
    <path d="M7 9v9" />
    <path d="M17 9v9" />
  </IconeProprio>
)

/** Colar cervical: a peça aberta, vista de frente. */
export const IconeColarCervical = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M6 9a6 6 0 0112 0" />
    <path d="M5 9h14v5a5 5 0 01-5 5h-4a5 5 0 01-5-5z" />
  </IconeProprio>
)

/** Coluna estrutural do veículo, com os reforços. */
export const IconeColuna = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M9 3l-2 18" />
    <path d="M15 3l2 18" />
    <path d="M8 10h8" />
    <path d="M7.5 15h9" />
  </IconeProprio>
)

/* --- Ferramentas da oficina de corte -------------------------------------- */

/** Cortador hidráulico de salvamento veicular (desencarcerador). */
export const IconeCortadorHidraulico = IconeOficinaCorte

/** Alargador: as ponteiras abertas em V sobre o corpo da ferramenta. */
export const IconeAlargador = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M5.5 3.5 10 10" />
    <path d="M18.5 3.5 14 10" />
    <rect x="10" y="10" width="4" height="5" rx="1" />
    <path d="M12 15v6" />
  </IconeProprio>
)

/** Extensor: o êmbolo telescópico entre os dois pratos de apoio. */
export const IconeExtensor = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M3 7.5v9" />
    <path d="M21 7.5v9" />
    <path d="M3 12h4" />
    <rect x="7" y="9.5" width="7" height="5" rx="1" />
    <path d="M14 12h7" />
  </IconeProprio>
)

/** Hooligan: a haste com o garfo numa ponta e o cinzel na outra. */
export const IconeHooligan = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M5.5 18.5 16 8" />
    <path d="m16 8 4-4" />
    <path d="m17.5 2.5 4 4" />
    <path d="m3.5 16.5 4 4" />
  </IconeProprio>
)

/** Machadinha: cabo diagonal e a lâmina em cunha curva na ponta. */
export const IconeMachadinha = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M4 20l7-7" />
    <path d="M11 13l3-6a4 4 0 0 1 6 4l-6 3z" />
  </IconeProprio>
)

/** Serra sabre: corpo da ferramenta, lâmina reta e os dentes serrilhados. */
export const IconeSerraSabre = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="3" y="9" width="8" height="6" rx="1.5" />
    <path d="M11 12h8" />
    <path d="M14 12l1.5-2M16.5 12l1.5-2M19 12l1.5-2" />
  </IconeProprio>
)

/** Sustentação da peça: o apoio recebendo a chapa antes da retirada. */
export const IconeSustentarPeca = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M4 5h16" />
    <path d="M12 5v8" />
    <path d="m7.5 21 4.5-8 4.5 8" />
  </IconeProprio>
)

/** Retirada da peça: a chapa saindo da estrutura. */
export const IconeRetirarPeca = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="3" y="4" width="7" height="16" rx="1" />
    <path d="M13 12h8" />
    <path d="m18 9 3 3-3 3" />
  </IconeProprio>
)

/** Pista de asfalto / rodovia: bordas da pista e faixa central tracejada. */
export const IconePistaAsfalto = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M4 22L7 2" />
    <path d="M20 22L17 2" />
    <path d="M12 5v3" />
    <path d="M12 11v3" />
    <path d="M12 17v3" />
  </IconeProprio>
)

/** Mancha de sangue: poça líquida orgânica com respingos e borda fluida. */
export const IconeManchaSangue = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M12 2.5c-2.5 4-6 8-6 12a6 6 0 0 0 12 0c0-4-3.5-8-6-12z" />
    <circle cx="18" cy="18" r="1.5" />
    <circle cx="6" cy="19" r="1" />
  </IconeProprio>
)

/** Extintor de incêndio PQS: cilindro vertical com gatilho, manômetro e mangueira difusora. */
export const IconeExtintor = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="8" y="7" width="8" height="14" rx="3" />
    <path d="M10 7V4h4v3" />
    <path d="M14 5h3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1" />
    <path d="M10 3h-2" />
  </IconeProprio>
)

/** Lona de ferramentas (Tool Staging Area): lona retangular com ferramentas dispostas. */
export const IconeLonaFerramentas = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="3" y="5" width="18" height="14" rx="1.5" />
    <path d="M7 9l4 4m0-4l-4 4" />
    <path d="M14 10h4v4h-4z" />
  </IconeProprio>
)

/** Mochila de trauma / kit de APH de resgate: mochila com cruz da vida. */
export const IconeMochilaTrauma = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="5" y="6" width="14" height="15" rx="2" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    <path d="M12 10v6" />
    <path d="M9 13h6" />
    <path d="M5 10H3v7h2" />
    <path d="M19 10h2v7h-2" />
  </IconeProprio>
)

